import React, { ReactNode } from 'react';
import styled from 'styled-components';

import {
  BUTTON_THEMES,
  BUTTON_TYPES,
  ELEMENT_ACTION,
  ICON_TYPES,
} from '../../../shared/constants';
import { IContentfulLink } from '../../../types/shared';

import PrimaryButton from '../../atoms/primary-button/PrimaryButton';

import { getCtaLink } from '../../../utils/generic';

import mq from '../../../styles/breakpoints';
import { Body } from '../../../styles/generic';
import Spacings from '../../../styles/Spacings';

import ModalHeader from '../modal-header/ModalHeader';

interface Props {
  title: string;
  children: ReactNode;
  buttonLabel?: string;
  primaryLink?: IContentfulLink;
  setShowModal: (event: boolean) => void;
  onButtonClick?: (event: unknown) => void;
}

export const SimpleContent = ({
  title,
  children,
  buttonLabel,
  primaryLink,
  setShowModal,
  onButtonClick,
}: Props) => (
  <Container data-testid="simple-content-modal">
    <ModalHeader>{title}</ModalHeader>
    <Paragraph>{children}</Paragraph>
    <CtaWrapper>
      {buttonLabel && (
        <PrimaryButton
          deqCustomAttributes={{
            elementAction: ELEMENT_ACTION.close,
          }}
          onButtonClick={() => onButtonClick || setShowModal(false)}
          buttonTheme={BUTTON_THEMES.muted}
          type={BUTTON_TYPES.action}
          icon={ICON_TYPES.none}
          label={buttonLabel}
        />
      )}
      {primaryLink && (
        <PrimaryButton
          onButtonClick={() => setShowModal(false)}
          to={getCtaLink(primaryLink)}
          buttonTheme={primaryLink.theme}
          type={primaryLink.type}
          icon={primaryLink.icon}
          label={primaryLink.label}
        />
      )}
    </CtaWrapper>
  </Container>
);

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const CtaWrapper = styled.div`
  column-gap: 0;
  display: flex;
  flex-direction: column-reverse;
  margin-top: ${Spacings.S};
  row-gap: ${Spacings.S};

  ${mq.from.breakpoint.M`
    flex-direction: row;
    row-gap: 0;
    column-gap: ${Spacings.S};
    justify-content: end;
  `}
`;

const Paragraph = styled(Body)`
  margin: 0;
`;
